export enum FEATURE_FLAG_KEYS_ENUM {
  IsDeveloper = 'is_developer',
  IsDemoAccount = 'is_demo_account',
  IsAlphaUser = 'is_alpha_user',
  IsBetaUser = 'is_beta_user', // inclusive of alpha users
  IsAllActivity = 'is_all_activity',
  IsInterview = 'is_interview',
  ShouldIncludeOpenTabs = 'should_include_open_tabs',
  ShouldPinSkeemaTab = 'should_pin_skeema_tab',
  ShouldHaveExpandedProjects = 'should_have_expanded_projects',
  ShouldHaveExperimentalPutaway = 'should_have_experimental_putaway',
  ShouldHaveExperimentalPutawayV2 = 'should_have_experimental_putaway_v2',
  ShouldKeepRelatedTabsOpen = 'should_keep_related_tabs_open',
  IsPaywallEnabled = 'is_paywall_enabled',
  IsConfigurable = 'is_configurable',
  ShouldHaveUnlimitedInstantSave = 'should_have_unlimited_instant_save',
  IsDefaultGuidedAutoSave = 'is_default_guided_auto_save',
  ShouldOverrideNewTabPage = 'should_override_new_tab_page',
  IsNewFolderCreationEnabled = 'is_new_folder_creation_enabled',
  ShouldCaptureExtensionLogs = 'should_capture_extension_logs',
  IsSimplifiedASTEnabled = 'is_simplified_ast_enabled',
  IsV3Onboarding = 'is_v3_onboarding',
  DoesFreeUserGetSessions = 'does_free_user_get_sessions',
  IsAbleToDeleteAccount = 'is_able_to_delete_account',
  DEPRECATED_ShouldPutawayOnUnfocusedWindows = 'should_putaway_on_unfocused_windows',
}

export type FeatureFlagValuesType = {
  [FEATURE_FLAG_KEYS_ENUM.IsDeveloper]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsDemoAccount]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsAlphaUser]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsBetaUser]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsAllActivity]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsInterview]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldIncludeOpenTabs]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldPinSkeemaTab]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveExpandedProjects]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveExperimentalPutaway]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveExperimentalPutawayV2]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldKeepRelatedTabsOpen]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsPaywallEnabled]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsConfigurable]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveUnlimitedInstantSave]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsDefaultGuidedAutoSave]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldOverrideNewTabPage]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsNewFolderCreationEnabled]: boolean
  [FEATURE_FLAG_KEYS_ENUM.ShouldCaptureExtensionLogs]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsSimplifiedASTEnabled]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsV3Onboarding]: boolean
  [FEATURE_FLAG_KEYS_ENUM.DoesFreeUserGetSessions]: boolean
  [FEATURE_FLAG_KEYS_ENUM.IsAbleToDeleteAccount]: boolean
  [FEATURE_FLAG_KEYS_ENUM.DEPRECATED_ShouldPutawayOnUnfocusedWindows]: boolean
}

export const DEFAULT_FEATURE_FLAG_VALUES: FeatureFlagValuesType = {
  [FEATURE_FLAG_KEYS_ENUM.IsDeveloper]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsDemoAccount]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsAlphaUser]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsBetaUser]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsAllActivity]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsInterview]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldIncludeOpenTabs]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldPinSkeemaTab]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveExpandedProjects]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveExperimentalPutaway]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveExperimentalPutawayV2]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldKeepRelatedTabsOpen]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsPaywallEnabled]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsConfigurable]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldHaveUnlimitedInstantSave]: false,
  [FEATURE_FLAG_KEYS_ENUM.DEPRECATED_ShouldPutawayOnUnfocusedWindows]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsDefaultGuidedAutoSave]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldOverrideNewTabPage]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsNewFolderCreationEnabled]: false,
  [FEATURE_FLAG_KEYS_ENUM.ShouldCaptureExtensionLogs]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsSimplifiedASTEnabled]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsV3Onboarding]: false,
  [FEATURE_FLAG_KEYS_ENUM.DoesFreeUserGetSessions]: false,
  [FEATURE_FLAG_KEYS_ENUM.IsAbleToDeleteAccount]: false,
}
